import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cache",
  "use": "icon-cache-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cache\"><defs><style type=\"text/css\"></style></defs><path d=\"M725.290667 343.402667v-99.306667L512 128l-213.290667 116.096-1.472 99.306667 214.826667 99.477333 213.226667-99.306667v99.477334L512 542.08l-0.490667 0.170667-212.8-99.221334v-99.477333L85.333333 442.88v252.266667l213.866667 99.221333L512 899.626667v-0.32l213.205333-104.853334L938.666667 695.146667V442.88z\" fill=\"#00C1DE\" p-id=\"4934\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cache.svg
// module id = sCmb
// module chunks = 329